import Box from '@mui/material/Box';
import Skeleton from '@mui/material/Skeleton';
import { type SxProps } from '@mui/material/styles';
import { type ComponentProps, useState } from 'react';

import { isVideo } from '../../utils/isVideo';
import { ProgressiveImage } from '../ProgressiveImage/ProgressiveImage';
import { Video } from '../Video/Video';

export type MediaItemProps = {
  media: string;
  alt?: string;
  handleSelect?: (src: string) => void;
  slotProps?: {
    video?: ComponentProps<typeof Video>;
    image?: Omit<ComponentProps<typeof ProgressiveImage>, 'src' | 'alt'>;
    loader?: {
      height?: string;
    };
  };
};

export const MediaItem = ({ media, alt, handleSelect, slotProps }: MediaItemProps) => {
  const [isRendering, setIsRendering] = useState(false);

  if (isVideo(media)) {
    return (
      <>
        {isRendering ? (
          <Box
            sx={{
              alignItems: 'center',
              display: 'flex',
              height: slotProps?.loader?.height ?? '100%',
              justifyContent: 'center',
              width: '100%',
            }}
          >
            <Skeleton variant="rectangular" width="100%" height="100%" />
          </Box>
        ) : null}
        <Video
          onLoadStart={() => {
            setIsRendering(true);
          }}
          onCanPlayThrough={() => {
            setIsRendering(false);
          }}
          onClick={() => handleSelect?.(media)}
          {...slotProps?.video}
          sx={{ display: isRendering ? 'none' : 'block', ...(slotProps?.video?.sx as SxProps) }}
        >
          <source src={media} />
        </Video>
      </>
    );
  }

  return <ProgressiveImage src={media} alt={alt} onClick={() => handleSelect?.(media)} {...slotProps?.image} />;
};
